import createAvailabilitySaga from './createAvailabilitySaga'
import editAvailabilitySaga from './editAvailabilitySaga'
import oneAvailabilitySaga from './oneAvailabilitySaga'
import validateLinkAvailabilitySaga from './availabilityValidateLinkSaga'
import syncSaga from './sync'
import syncAuthenticateURLSaga from './syncAuthenticateURL'
import getConnectedCalendarSaga from './getConnectedCalendar'
import removeSyncSaga from './removeSync'

const calendarSagas = [
    createAvailabilitySaga(),
    editAvailabilitySaga(),
    oneAvailabilitySaga(),
    validateLinkAvailabilitySaga(),
    syncSaga(),
    syncAuthenticateURLSaga(),
    getConnectedCalendarSaga(),
    removeSyncSaga()
]

export default calendarSagas
